export default __webpack_public_path__ + "static/pomodoro-timer@2x-b90468480851065025fbc2d5ab1ca1db.png";